import {
  TYPES as PROJECTS_STORES_TYPES,
  ProjectStoreInjector,
} from '@desygner/ui-features-projects';

import { appContainer } from '../../../inversify.config';
import { TYPES } from '../../../inversify.types';
import { IViewerStoreInjector } from '../../../store';
import { AnimationManager } from '../animation-manager';
import { VideoManager } from '../video-manager';
import { VirtualizerService } from '../virtualizer-service';

export const arrowDownShortcut = {
  key: new Set(['ArrowDown']),
  callBackFunction: async () => {
    const { project } = appContainer
      .get<ProjectStoreInjector>(PROJECTS_STORES_TYPES.ProjectsStore)
      .getState();
    const { animateOut } = appContainer.get<AnimationManager>(TYPES.Viewer.AnimationManager);
    const virtualizer = appContainer.get<VirtualizerService>(TYPES.Viewer.VirtualizerService);
    const videoManager = appContainer.get<VideoManager>(TYPES.Viewer.VideoManager);

    const { setSelectedPageNumber, selectedPageNumber, pageMode } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();
    const totalPages = project?.currentProject?.total_pages ?? 0;
    const currentPage = selectedPageNumber + 1 > totalPages ? 1 : selectedPageNumber + 1;

    if (pageMode === 'single') {
      await animateOut();
      videoManager.pauseCurrentActiveVideo();
    }

    virtualizer.scrollToIndex(currentPage - 1);
    setSelectedPageNumber(currentPage);
  },
};
